import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import React from 'react';

import events from 'events.js';

import FocusManager from 'core/components/FocusManager.js';
import {
    PracticeStoreContext,
    HospitalStoreContext,
} from 'core/stores/RootStore.js';
import PracticeContent from 'practices/components/PracticeContent.js';
import PracticeHeader from 'practices/components/PracticeHeader.js';
import PracticeSidebar from 'practices/components/PracticeSidebar.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';

export default
@observer
class HospitalApp extends React.Component {
    static contextType = PracticeStoreContext;

    static propTypes = {
        practice: PropTypes.object.isRequired,
        searchText: PropTypes.string,
        userType: PropTypes.string,
    };

    static defaultProps = {
        searchText: '',
    };

    componentDidMount() {
        const {practice, searchText, userType} = this.props;
        this.context.updateStore({
            practice,
            searchText,
            practiceLoaded: true,
            userType,
        });
    }

    render() {
        const {displayedModal, renderModal} = this.context;
        return (
            <>
                <FocusManager />
                <PracticeHeader />
                <PracticeContent />
                {/* cant get the practice info via store when using componentDidMount */}
                <PracticeSidebar hospitalId={this.props.practice.id} />
                {displayedModal && renderModal()}
            </>
        );
    }
}

(async function () {
    await events.ready();
    const hospitalDetailSection = document.getElementById('hospital-page');
    const {searchTerm, userType} = document.body.dataset;
    const props = {
        practice: snakeToCamelObjectKeys(
            JSON.parse(hospitalDetailSection.dataset.hospitalProps),
        ),
        searchText: searchTerm,
        userType,
    };

    ReactDOM.render(
        <PracticeStoreContext.Provider value={HospitalStoreContext}>
            <HospitalApp {...props} />
        </PracticeStoreContext.Provider>,
        hospitalDetailSection,
    );
})();
